import { useEffect, useRef, useState } from 'react';
export function useWidth() {
    const [width, setWidth] = useState(0);
    const containerRef = useRef(null);
    useEffect(() => {
        const observer = new ResizeObserver((entries) => {
            if (entries[0]) {
                setWidth(entries[0].contentRect.width);
            }
        });
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return () => {
            if (containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);
    return [width, containerRef];
}
